"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCString = exports.toDataView = exports.Binary = void 0;
exports.Binary = { toDataView, toCString };
function toDataView(buffer) {
    return new DataView(buffer.buffer, buffer.byteOffset, buffer.length);
}
exports.toDataView = toDataView;
function toCString(buffer) {
    const dv = toDataView(buffer);
    let s = '';
    for (let i = 0; i < dv.byteLength; ++i) {
        const c = dv.getInt8(i);
        if (c === 0)
            return s;
        s += String.fromCharCode(c);
    }
    return s;
}
exports.toCString = toCString;
